import { render } from "./iconYoutube.vue?vue&type=template&id=42ddc3cd&scoped=true"
import script from "./iconYoutube.vue?vue&type=script&lang=js"
export * from "./iconYoutube.vue?vue&type=script&lang=js"

import "./iconYoutube.vue?vue&type=style&index=0&id=42ddc3cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42ddc3cd"

export default script